import React from 'react';
import IconWrapper from '../../../IconWrapper';
const LogoutIconSmall = (props) => (React.createElement(IconWrapper, { size: "small", ...props },
    React.createElement("path", { d: "M5.5 1a.5.5 0 0 0 0-1h-5a.5.5 0 0 0-.5.5v15a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 0-1H1V1h4.5Z" }),
    React.createElement("path", { d: "M10.05 3.126a.5.5 0 0 0-.685.729l3.88 3.643H4.5a.5.5 0 0 0 0 1h8.74l-3.872 3.636a.5.5 0 0 0 .684.729l4.793-4.5a.5.5 0 0 0 .124-.546.498.498 0 0 0-.127-.191l-4.793-4.5Z" })));
export default LogoutIconSmall;
//# sourceMappingURL=LogoutIconSmall.js.map